var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 2.375H3.125C2.24125 2.375 1.79938 2.375 1.525 2.6325C1.25 2.89 1.25 3.305 1.25 4.13438V4.56563C1.25 5.21375 1.25 5.53813 1.4125 5.80688C1.575 6.07563 1.87063 6.24313 2.46375 6.57688L4.28438 7.60188C4.68188 7.82563 4.88125 7.9375 5.02375 8.06125C5.32 8.31813 5.5025 8.62063 5.585 8.9925C5.625 9.17 5.625 9.37875 5.625 9.79563V11.4644C5.625 12.0325 5.625 12.3169 5.7825 12.5381C5.94 12.76 6.22 12.8694 6.77875 13.0881C7.95313 13.5469 8.54 13.7763 8.9575 13.515C9.375 13.2544 9.375 12.6575 9.375 11.4638V9.795C9.375 9.37875 9.375 9.17 9.415 8.99188C9.49349 8.6276 9.69121 8.2999 9.97688 8.06063C10.1188 7.9375 10.3181 7.82563 10.7156 7.60125L12.5363 6.57625C13.1288 6.24313 13.4256 6.07625 13.5875 5.8075C13.75 5.53875 13.75 5.21375 13.75 4.565V4.13375C13.75 3.305 13.75 2.89 13.475 2.6325C13.2013 2.375 12.7594 2.375 11.875 2.375Z",
    stroke: "#2A2E34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.53d647831de1a9bd34202bd001a54b2f.svg";
export { ForwardRef as ReactComponent };